import { createSlice } from "@reduxjs/toolkit"
import { AppThunk } from "./app"
import api from "./api"
import API_URL from "../config/ApiUrl"

const PortingReportSlice = createSlice({
    name: "PortingReportSlice",
    initialState: {},
    reducers: {}
})
export const addPortingReport = (payload?: any): AppThunk<any> => async (dispatch) => {
    try {
        const res = await api.post(API_URL.PORTING_REPORTS.ADD, payload);
        return Promise.resolve(res.data)
    } catch (error: any) {
        return Promise.reject(error.data)
    }
}
export const fetchListPortingReports = (payload?: any): AppThunk<any> => async () => {    
    try {
        const type = payload.type ? payload.type : "";
        const report_year = payload.report_year ? payload.report_year : "";
        const report_date = payload.report_date ? payload.report_date : "";
        const current = payload.current ? payload.current : 1;
        const page_size = payload.page_size ? payload.page_size : 10;
        const provider_code = payload.provider_code ? payload.provider_code : "";

        const action = `?type=${type}&report_year=${report_year}&report_date=${report_date}&current=${current}&page_size=${page_size}&provider_code=${provider_code}`

        const response = await api.get(API_URL.PORTING_REPORTS.LIST + action);
        return Promise.resolve(response?.data?.data);
    } catch (error: any) {
        return Promise.reject(error.data);
    }
};
export const fetchDeletePortingReports = (payload?: any): AppThunk<any> => async (dispatch) => {
    try {
        const response = await api.post(API_URL.PORTING_REPORTS.DELETE, payload);
        return Promise.resolve(response.data);
    } catch (error: any) {
        return Promise.reject(error.data);
    }
};

export default PortingReportSlice.reducer
